import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { ViguideRecommendationActions } from './viguide-recommendations.actions';
import { ViguideRecommendationsState } from './viguide-recommendations.state';

export const initViguideRecommendationsState: ViguideRecommendationsState = {
  optimizationRecommendations: [],
  loading: false,
  loaded: false,
  error: null,
  ignoredTilesSettings: null,
  proInstallations: [],
};

export const viguideRecommendationsReducer: ActionReducer<
  ViguideRecommendationsState,
  Action
> = createReducer(
  initViguideRecommendationsState,
  on(
    ViguideRecommendationActions.getOptimizationRecommendationsAttempt,
    (): ViguideRecommendationsState => ({
      ...initViguideRecommendationsState,
      optimizationRecommendations: [],
      loading: true,
      loaded: false,
      error: null,
    })
  ),
  on(
    ViguideRecommendationActions.getOptimizationRecommendationsSuccess,
    (state, { optimizationRecommendations }): ViguideRecommendationsState => ({
      ...state,
      optimizationRecommendations,
      loading: false,
      loaded: true,
      error: null,
    })
  ),
  on(
    ViguideRecommendationActions.getOptimizationRecommendationsError,
    (state, { error }): ViguideRecommendationsState => ({
      ...state,
      loading: false,
      loaded: false,
      error,
    })
  ),
  on(
    ViguideRecommendationActions.updateIgnoredRecommendationTilesSettings,
    (state, { ignoredTilesSettings }): ViguideRecommendationsState => ({
      ...state,
      ignoredTilesSettings,
    })
  ),

  on(
    ViguideRecommendationActions.fetchProInstallations.attempt,
    (state): ViguideRecommendationsState => {
      return {
        ...state,
        proInstallations: [],
      };
    }
  ),

  on(
    ViguideRecommendationActions.fetchProInstallations.success,
    (state, { installations }): ViguideRecommendationsState => {
      return {
        ...state,
        proInstallations: installations,
      };
    }
  )
);
